var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3 3A2.2 2.2 0 013.5.8h10A2.2 2.2 0 0115.7 3v7.6a2.2 2.2 0 01-2.2 2.2h-2.4a1 1 0 00-.8.4l-1.32 1.76a.6.6 0 01-.96 0L6.7 13.2a1 1 0 00-.8-.4H3.5a2.2 2.2 0 01-2.2-2.2V3zm2.2-1a1 1 0 00-1 1v7.6a1 1 0 001 1h2.4a2.2 2.2 0 011.76.88l.84 1.12.84-1.12a2.2 2.2 0 011.76-.88h2.4a1 1 0 001-1V3a1 1 0 00-1-1h-10z",
    fill: "#272E35"
  })));
}
export default SvgComment;